import React, { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";
import projectApi from "@/redux/api/projectApi";
import { useAppSelector } from "@/hooks/redux";
import { getDashBoardState } from "@/redux/store";


export default function Gateway() {
  const router = useRouter();
  const [createProject] = projectApi.useCreateProjectMutation();
  const { accountUserInfo, workspaceList, selectedWorkspaceIndex } = useAppSelector((store) => getDashBoardState(store) ?? false );
  const currentWorkspace = workspaceList[selectedWorkspaceIndex] || { workspaceId: accountUserInfo?.workspaceId, isPrivate: true};
  

  const makeProjectByGateway = useCallback(async (params: any) => {
    const { templateId, aiName, clothId } = params;
    if(templateId) { //template
      const res = await createProject({ templateId, workspaceId: currentWorkspace?.workspaceId }).unwrap();
      if (!res.success) {
        router.push("dashboard")
        alert(res.error?.msg);
        return
      }
      const { projectId } = res.data;
      router.push(`/editor/${projectId}`);
    } else {  //avatar
      const res = await createProject({ aiName, clothId, workspaceId: currentWorkspace?.workspaceId }).unwrap();
      if (!res.success) {
        router.push("dashboard")
        alert(res.error?.msg);
        return
      }
      const { projectId } = res.data;
      router.push(`/editor/${projectId}`);
    }
  }, [createProject, currentWorkspace?.workspaceId, router])

  useEffect( () => {
    if ( router.isReady ) {
      if( router.query.template ) {
        console.log("!@#!@#!@# ", router.query);
        makeProjectByGateway({
          templateId: router.query.template
        })
      } else if( router.query.model && router.query.clothes) {
        console.log("!@#!@#!@# ", router.query);
        makeProjectByGateway({
          aiName: router.query.model,
          clothId: router.query.clothes
        })
      } else {
        router.push("dashboard")
      }
    }
  }, [router.isReady, router.query])

  return
    <div>
    </div>
}

